<template>
  <div>
    <div id="outer-container">
      <div ref="navButtons" class="card mar-bt-0 mar-to-10 max-z-index navButtons">
        <div class="card-content">
          <div class="clearfix row pad-lf-10 pad-rg-10">

            <!-- TAB 1 -->
            <a
              class="btn btn-fill btn-primary"
              :class="{ active: isAccountingInboundInvoices }"
              @click="openAccountingInboundInvoices"
            >
              {{ $t('gestiune.inboundInvoices') }}
            </a>

            <!-- TAB 2 -->
            <a
              class="btn btn-fill btn-primary"
              :class="{ active: isAccountingSales }"
              @click="openAccountingSales"
            >
              {{ $t('gestiune.accountingSales') }}
            </a>

          </div>
        </div>
      </div>
    </div>

    <!-- ACCOUNTING INBOUND INVOICES -->
    <div v-if="isAccountingInboundInvoices">
      <AccountingInboundInvoices
        :grouped-locations="groupedLocations"
        :gestiuneOptions="gestiuneOptions"
      />
    </div>

    <!-- ACCOUNTING SALES -->
    <div v-if="isAccountingSales">
      <AccountingSales
        :grouped-locations="groupedLocations"
        :gestiuneOptions="gestiuneOptions"
      />
    </div>
  </div>
</template>

<script>
import AccountingInboundInvoices from 'src/components/Dashboard/Views/Management/Accounting/AccountingInboundInvoices.vue'
import AccountingSales from 'src/components/Dashboard/Views/Management/Accounting/AccountingSales.vue'

export default {
  components: {
    AccountingInboundInvoices,
    AccountingSales
  },

  props: {
    groupedLocations: {
      type: Array,
      required: true
    },
    gestiuneOptions: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      isAccountingInboundInvoices: true,
      isAccountingSales: false
    }
  },

  methods: {
    openAccountingInboundInvoices () {
      this.isAccountingInboundInvoices = true
      this.isAccountingSales = false
    },

    openAccountingSales () {
      this.isAccountingInboundInvoices = false
      this.isAccountingSales = true
    }
  }
}
</script>

<style scoped>
.form-check {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.left-buttons {
  display: flex;
}

.left-buttons el-button {
  margin-right: 10px;
}

.right-button {
  margin-left: auto;
}

.button-group {
  display: flex;
  justify-content: flex-end;
}

.button-group .btn {
  margin-right: 10px;
}

.button-group .btn:last-child {
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/ManagementExports.vue